import { useState, useMemo } from 'react';

function useToggle(defaultValue, reverseValue) {
  if (defaultValue === void 0) {
    defaultValue = false;
  }

  var _useState = useState(defaultValue),
      state = _useState[0],
      setState = _useState[1];

  var reverseValueOrigin = useMemo(function () {
    return reverseValue === undefined ? !defaultValue : reverseValue;
  }, [reverseValue]);
  var actions = useMemo(function () {
    // 切换返回值
    var toggle = function toggle(value) {
      // 强制返回状态值，适用于点击操作
      if (value !== undefined) {
        setState(value);
        return;
      }

      setState(function (s) {
        return s === defaultValue ? reverseValueOrigin : defaultValue;
      });
    }; // 设置默认值


    var setLeft = function setLeft() {
      return setState(defaultValue);
    }; // 设置取反值


    var setRight = function setRight() {
      return setState(reverseValueOrigin);
    };

    return {
      toggle: toggle,
      setLeft: setLeft,
      setRight: setRight
    };
  }, [setState]);
  return [state, actions];
}

export default useToggle;